// apihook.js
import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

const useApi = (url, initialPayload) => {
    const [payload, setPayload] = useState(initialPayload);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        const sendRequest = async () => {
            if (!payload) return;

            setLoading(true);
            setError(null);
            setResponse(null);

            try {
                const res = await axios.post(url, payload);
                setResponse(res.data);
                toast.success(res?.message || "Password created successfully!");
                navigate('/login');
            } catch (err) {
                setError(err);
                toast.error("Failed to update password");
                console.error("API Error:", err);
            } finally {
                setLoading(false);
            }
        };

        sendRequest();
    }, [payload, url]);

    const triggerPost = (data) => {
        setPayload(data);
    };

    return { triggerPost, loading, error, response };
};

export default useApi;